import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { Segment, Header } from "semantic-ui-react";
import { actividadesOps } from "../../../ducks/actividades";
import { busquedasOps } from "../../../ducks/busquedas";
import { asignacionesOps } from "../../../ducks/asignaciones";
import TablaActividadesAsignadas from "./asignacionActividades/TablaActividadesAsignadas";
import ActividadesDisponibles from "./asignacionActividades/ActividadesDisponibles";
import _ from "lodash";
import moment from "moment";
import InputData from "../InputData";

class AsignacionActividades extends React.Component {
  state = {
    showInputData: false,
    titulo: "",
    nombre: "",
    value: "",
    idActividadAsignada: "",
    redirect: false,
    link: null
  };

  componentDidMount() {
    // this.props.obtenerActividadesAsignadas(this.props.detalleColegio.id);
    this.props.obtenerActividadesAsignadas(this.props.idColegio);
    this.props.obtenerListaActividades();
    this.props.fetchSearchDataActividades();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.idColegio !== this.props.idColegio) {
      this.props.detachActividadesAsignadas(prevProps.idColegio);
      this.props.obtenerActividadesAsignadas(this.props.idColegio);
    }
  }

  componentWillUnmount() {
    this.props.resetActividadesAsignadas();
    this.props.resetListaActividades();
    this.props.resetSearchDataActividades();
    this.props.detachActividadesAsignadas(this.props.idColegio);
  }

  handleShowInput = () =>
    this.setState(state => ({
      showInputData: !state.showInputData,
      nombre: "",
      titulo: "",
      value: "",
      idActividadAsignada: "",
      redirect: false,
      link: null
    }));

  handleClickDisponibles = value => {
    const asignada = this.checkActividadYaAsignada(value);

    if (!asignada) {
      let data = this.props.listaActividades.filter(act => act.id === value)[0];
      data.idColegio = this.props.idColegio;
      data.nombreColegio = this.props.nombreColegio;
      this.props.saveAsignacionActividades(data);
    } else {
      alert("La actividad ya está asignada");
    }
  };

  handleRowClick = (nombre, value, titulo, idActividadAsignada) => {
    if (nombre === "alumnos") {
      let data = this.props.actividadesAsignadas.filter(
        act => act.id === idActividadAsignada
      )[0];
      let params = {
        idColegio: this.props.idColegio,
        idActividad: idActividadAsignada,
        nombreColegio: this.props.nombreColegio,
        actividad: data.actividad
      };

      this.props.setAsignacionData(params);

      this.setState({
        redirect: true,
        link: <Redirect to={`/asignacionAlumnos/${this.props.idColegio}`} />
      });
    } else {
      this.setState(state => ({
        showInputData: !state.showInputData,
        nombre,
        titulo,
        value,
        idActividadAsignada,
        redirect: false,
        link: null
      }));
    }
  };

  handleSaveModal = (name, value) => {
    this.props.updateActividadAsignada({
      idColegio: this.props.idColegio,
      idActividadAsignada: this.state.idActividadAsignada,
      name,
      value
    });

    this.setState(state => ({
      showInputData: !state.showInputData,
      nombre: "",
      titulo: "",
      value: "",
      idActividadAsignada: "",
      redirect: false,
      link: null
    }));
  };

  checkActividadYaAsignada = idActividad => {
    const { actividadesAsignadas } = this.props;
    let asignada = false;

    let index = _.findIndex(actividadesAsignadas, { idActividad });

    asignada = index > -1;

    if (asignada) {
      const fechaFin = actividadesAsignadas[index].fechaFin;
      asignada = !moment(fechaFin).isValid();
    }

    return asignada;
  };

  render() {
    if (this.state.redirect) {
      return this.state.link;
    }

    return (
      <Segment>
        <Segment>
          <Header as="h2">Asignación de Actividades al Colegio</Header>
          <ActividadesDisponibles
            datosBusqueda={this.props.searchDataActividades}
            handleButtonClick={this.handleClickDisponibles}
          />
        </Segment>
        <Segment>
          <Header as="h3">Asignadas</Header>
          <TablaActividadesAsignadas
            datos={this.props.actividadesAsignadas}
            handleRowClick={this.handleRowClick}
          />
        </Segment>
        {this.state.showInputData && (
          <InputData
            titulo={this.state.titulo}
            nombre={this.state.nombre}
            value={this.state.value}
            show={this.state.showInputData}
            closeDialog={this.handleShowInput}
            saveModal={this.handleSaveModal}
          />
        )}
      </Segment>
    );
  }
}

const mapStateToProps = state => ({
  listaActividades: state.actividades.listaActividades,
  searchDataActividades: state.busquedas.searchDataActividades,
  actividadesAsignadas: state.asignaciones.actividadesAsignadas,
  detalleColegio: state.colegios.detalleColegio
});

const actions = {
  obtenerListaActividades: actividadesOps.obtenerListaActividades,
  resetListaActividades: actividadesOps.resetListaActividades,
  resetSearchDataActividades: busquedasOps.resetSearchDataActividades,

  fetchSearchDataActividades: busquedasOps.fetchSearchDataActividades,

  obtenerActividadesAsignadas: asignacionesOps.obtenerActividadesAsignadas,
  resetActividadesAsignadas: asignacionesOps.resetActividadesAsignadas,
  setAsignacionData: asignacionesOps.setAsignacionData,
  updateActividadAsignada: asignacionesOps.updateActividadAsignada,
  saveAsignacionActividades: asignacionesOps.saveAsignacionActividades,
  detachActividadesAsignadas: asignacionesOps.detachActividadesAsignadas
};

export default connect(mapStateToProps, actions)(AsignacionActividades);



// WEBPACK FOOTER //
// ./src/pages/shared/colegios/AsignacionActividades.jsx